





















































































































































































































































































































import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { translate } from "../../services/translation/translation";
import { Project, ProjectEvent } from "../../model/project";
import Vote from "../vote/vote.vue";
import "./project-page.less";
import ProjectGalleries from "@/components/project-galleries/project-galleries.vue";
import { dataService } from "../../services/data/data-service";
import ColorToneCard from "./color-tone.vue";

import {
  getAllVoted,
  getCategorySwitch,
  getNavigationData,
  getProjectData,
  getVotingEnabledData
} from "@/services/getProjectData/getProjectData";
import juryModalChangeCategory from "@/components/jury-modal-change-category/jury-modal-change-category.vue";
import { getNextUrl } from "@/services/webclient/webclient";
import BadgesComponent from "@/components/badges/badges.vue";

@Component({
  components: {
    Vote,
    ProjectGalleries,
    juryModalChangeCategory,
    BadgesComponent,
    ColorToneCard
  }
})
export default class ProjectPage extends Vue {
  @Prop() year!: string;

  private project: any = {};
  private navigations: { prev: string; next: string } = { prev: "", next: "" };
  private voting_enabled = 0;
  private width = 0;
  private next_url = "";
  private juryModalVisible = false;
  private category_switch = false;
  private categories: any[] = new Array();

  isExist(attributes: any) {
    if (
      typeof attributes == undefined ||
      attributes == null ||
      attributes == ""
    ) {
      return false;
    } else {
      return true;
    }
  }

  sortImages(images) {
    let sortedArray: any = [];
    $.each(images, function(index, element) {
      if (element.is_cover == 1) {
        sortedArray.unshift(element);
      } else {
        sortedArray.push(element);
      }
    });
    return sortedArray;
  }
  mounted() {
    this.project = getProjectData();
    this.navigations = getNavigationData();
    this.voting_enabled = getVotingEnabledData();
    this.categories = dataService.categories;
    this.getWidth();
    setTimeout(() => {
      this.updateLayout();
    }, 1000);
    setTimeout(() => {
      getNextUrl(this.year, this.project.id)
        .then(data => {
          this.next_url = data.next_url;
          this.category_switch = data.category_switch;
        })
        .catch(err => console.log(err));
    }, 500);
    try {
      window.addEventListener('resize', this.updateLayout);
      window.addEventListener('orientationchange', this.updateLayout);
    } catch (e) {

    }
  }

  getWidth() {
    this.width = screen.width;
  }

  getCategory(id) {
    let category = this.categories.filter(function(category) {
      return category.id == id;
    });
    if (category.length > 0) {
      return category[0].name;
    } else {
      return "";
    }
  }
  updateLayout() {
    var players = $(".lc-youtube");
    // console.log(players);
    players.each((i, p) => {
      let player = $(p);

      let screenX: number | undefined = player.parent().width();

      if (typeof screenX != "undefined") {
        //calc 16:9
        let screenY: number | undefined = (screenX / 16) * 9;

        //set palyer
        player.width(screenX);
        player.height(screenY);
      }
    });
  }
  getBadgesData() {
    return {
      nominee: this.project!.life_challenge_nominee,
      winner: this.project!.life_challenge_winner,
      total_winner: this.project!.life_challenge_total_winner,
      public_winner: this.project!.life_challenge_public_winner
    };
  }

  getAttachmentName(source) {
    if (source != "") {
      source = source.split("/");
      return source[source.length - 1];
    } else {
      return "";
    }
  }

  trans(key) {
    return translate(key);
  }

  isJury() {
    return dataService.isJuryUser();
  }

  getCategorySwitch() {
    return getCategorySwitch();
  }
  getAllVoted() {
    return getAllVoted();
  }

  @Watch("voted", { immediate: true, deep: true })
  onVoted(data) {
    if (data !== undefined && data > 0 && this.navigations.next != "") {
      if (this.isJury() && (this.getCategorySwitch() || this.category_switch)) {
        this.juryModalVisible = true;
      } else if (this.next_url != "") {
        setTimeout(() => {
          window.location.href = this.next_url;
        }, 2100);
      }
    }
  }

  @Watch("settingJuryModalVisible", { immediate: true, deep: true })
  onSettingJuryModalVisible(juryModalVisible) {
    this.juryModalVisible = juryModalVisible;
  }
}
